import React from 'react';

type CalloutTone = 'note' | 'insight' | 'warning';

type CalloutProps = {
  tone?: CalloutTone;
  title?: string;
  children: React.ReactNode;
};

function Callout({ tone = 'note', title, children }: CalloutProps) {
  return (
    <aside className={`callout callout-${tone}`}>
      {title ? <p className="callout-title">{title}</p> : null}
      <div>{children}</div>
    </aside>
  );
}

export default Callout;
